import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { formatUnderScoreLowerCase, getAmplitudeKeyValue } from '@utils/utils';

export function logPageBack(
  productConfig: { transaction_category_id: string },
  source: string,
  validatedReferralCode: string | null,
): void {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.BillPayment.userClickedBack.name, {
    [AMPLITUDE_CONSTANTS.BillPayment.userClickedBack.attributes.transaction_category_id]:
      productConfig.transaction_category_id,
    [AMPLITUDE_CONSTANTS.BillPayment.userClickedBack.attributes.source]: source,
    [AMPLITUDE_CONSTANTS.BillPayment.userClickedBack.attributes.referral_code]: validatedReferralCode,
  });
}

export function logPageLaunch(
  productConfig: { transaction_category_id: string },
  source: string,
  validatedReferralCode: string | null,
  isFavourite: boolean,
): void {
  const e = AMPLITUDE_CONSTANTS.BillPayment.ProductPage;
  const { name, attributes } = e;
  AmplitudeHelper.logEvent(name, {
    [attributes.transaction_category_id]: productConfig.transaction_category_id,
    [attributes.source]: source,
    [attributes.referral_code]: validatedReferralCode,
    [attributes.is_favourite]: isFavourite,
  });
}

export function logNominalsPress(
  selectedAccountNumber: string,
  item: { code: string; nominal?: { value: number } },
  productConfig: { transaction_category_id?: string; reason?: string; reasonId?: string },
  source: string,
  validatedReferralCode: string | null,
  isFavourite: boolean,
): void {
  const e = AMPLITUDE_CONSTANTS.BillPayment.userChoosesNominal;
  const { attributes, name } = e;
  AmplitudeHelper.logEvent(name, {
    [attributes.account_number]: selectedAccountNumber,
    [attributes.product_price]: item?.nominal?.value ?? 0,
    [attributes.product_code]: item.code,
    [attributes.transaction_category_id]: productConfig?.transaction_category_id,
    [attributes.source]: source,
    [attributes.reason]: productConfig.reason,
    [attributes.reason_id]: productConfig.reasonId,
    [attributes.referral_code]: validatedReferralCode,
    [attributes.is_favourite]: isFavourite,
  });
}

export function logRequestBP(
  selectedAccountNumber: string,
  productConfig: { transaction_category_id?: string; reason?: string; reasonId?: string },
  item: { code?: string },
  source: string,
  validatedReferralCode: string | null,
  meAmplitudeContext: any[],
  amplitudeAccountName: string,
  isFavourite: boolean,
): void {
  const e = AMPLITUDE_CONSTANTS.BillPayment.verifyingBillPaymentTransaction;
  const { name, attributes } = e;

  AmplitudeHelper.logEvent(name, {
    [attributes.account_number]: selectedAccountNumber,
    [attributes.transaction_category_id]: productConfig?.transaction_category_id,
    [attributes.product_code]: item?.code,
    [attributes.reason]: productConfig?.reason,
    [attributes.reason_id]: productConfig?.reasonId,
    [attributes.source]: source,
    [attributes.referral_code]: validatedReferralCode,
    [attributes.dynamic_account_name]: amplitudeAccountName,
    [attributes.is_favourite]: isFavourite,
    ...getAmplitudeKeyValue(e.name, meAmplitudeContext),
  });
}

export function logErrorOnAnalytics(
  isBPReqError: boolean,
  selectedAccountNumber: string,
  productConfig: { transaction_category_id: string; reason?: string; reasonId?: string },
  apiPayload: { productCode: string },
  t: (key: string) => string,
  bpError: any,
  source: string,
  validatedReferralCode: string | null,
  isFavourite: boolean,
): void {
  if (isBPReqError && bpError) {
    const e = AMPLITUDE_CONSTANTS.BillPayment.verifyTransactionFailed;
    const { name, attributes } = e;
    AmplitudeHelper.logEvent(name, {
      [attributes.account_number]: selectedAccountNumber,
      [attributes.transaction_category_id]: productConfig.transaction_category_id,
      [attributes.product_code]: apiPayload.productCode,
      [attributes.reason]: productConfig.reason,
      [attributes.reason_id]: productConfig.reasonId,
      [attributes.failure_message]: formatUnderScoreLowerCase(t(`errorCodes.${bpError[0]}`)),
      [attributes.source]: source,
      [attributes.referral_code]: validatedReferralCode,
      [attributes.is_favourite]: isFavourite,
    });
  }
}
